import PageHeader from '@/components/layouts/PageHeader'
import FlexBalanceResourceSteeringGrid from '@/features/flexBalance/components/ResourceSteeringGrid'
import { useFlexBalanceResourceQuery } from '@/features/flexBalance/hooks/useFlexBalanceResourceQuery'

const FlexBalanceIndex = () => {
  const { flexBalanceResources } = useFlexBalanceResourceQuery()

  return (
    <>
      <PageHeader isRoot pageTitle="FlexBalance" />
      <FlexBalanceResourceSteeringGrid flexBalanceResources={flexBalanceResources ?? []} />
    </>
  )
}

export default FlexBalanceIndex
